
export enum DictionaryCategory {
    Conversation = "conversation",
    Food = "food",
    Insults = "insults",
    PickUp = "pick-up",
    Aliexpress = "aliexpress",
    Names = "names"
}

export const DictionaryCategories: { [key in DictionaryCategory]: { name: string, icon?: string }} = {
    [DictionaryCategory.Conversation]: {
        name: 'Konversation',
        icon: 'mdi-account-multiple'
    },
    [DictionaryCategory.Food]: {
        name: 'Essen & Trinken',
        icon: 'mdi-food'
    },
    [DictionaryCategory.Insults]: {
        name: 'Beleidigungen',
        icon: 'mdi-chat-alert'
    },
    [DictionaryCategory.PickUp]: {
        name: 'Anmachsprüche',
        icon: 'mdi-heart'
    },
    [DictionaryCategory.Aliexpress]: {
        name: 'Aliexpress',
        icon: 'mdi-shopping'
    },
    [DictionaryCategory.Names]: {
        name: 'Namen',
        icon: 'mdi-account'
    }
}


export interface DictionaryEntry {
    id: string;
    german: string;
    chinese: string;
    pronunciation: string;
    category: DictionaryCategory[];
    audio?: string;
    description?: string;
    image?: string;
    similar?: string[];
}



export const dictionary: DictionaryEntry[] = [
    // CONVERSATION
    {
        id: 'hallo',
        german: 'Hallo',
        chinese: '你好',
        pronunciation: 'Nǐ hǎo',
        category: [DictionaryCategory.Conversation]
    },
    {
        id: 'ja',
        german: 'Ja',
        chinese: '是',
        pronunciation: 'Shì',
        category: [DictionaryCategory.Conversation],
        similar: ['nein']
    },
    {
        id: 'nein',
        german: 'Nein',
        chinese: '不',
        pronunciation: 'Bù',
        category: [DictionaryCategory.Conversation],
        similar: ['ja'],
        description: '<p>Ähnlich: 没有 (Méiyǒu)</p>Beispiel: Scheint heute die Sonne? - 不<br>Hast du schon gegessen? - 没有'
    },
    {
        id: 'danke',
        german: 'Danke',
        chinese: '谢谢',
        pronunciation: 'Xièxiè',
        category: [DictionaryCategory.Conversation]
    },
    {
        id: 'rutsch',
        german: 'Rutsch!',
        chinese: '过去点',
        pronunciation: 'Guòqù diǎn',
        category: [DictionaryCategory.Conversation]
    },
    {
        id: 'stueckpreis',
        german: 'Hau mal n Stückpreis raus',
        chinese: '出个单价吧',
        pronunciation: 'Chū gè dānjià ba',
        category: [DictionaryCategory.Conversation, DictionaryCategory.Aliexpress],
    },
    {
        id: 'genie',
        german: 'Genie',
        chinese: '天才',
        pronunciation: 'Tiāncái',
        category: [DictionaryCategory.Conversation]
    },
    {
        id: 'nigga',
        german: 'Das hier',
        chinese: '那个',
        pronunciation: 'Nàgè',
        category: [DictionaryCategory.Conversation]
    },


    // FOOD
    {
        id: 'hunger',
        german: 'Ich habe Hunger',
        chinese: '我饿了',
        pronunciation: 'Wǒ èle',
        category: [DictionaryCategory.Food, DictionaryCategory.Conversation],
        similar: ['bier']
    },
    {
        id: 'bier',
        german: 'Ein Glas Bier',
        chinese: '一杯啤酒',
        pronunciation: 'Yībēi píjiǔ',
        category: [DictionaryCategory.Food],
        similar: ['hunger']
    },
    {
        id: 'kungpaotofu',
        german: 'Kung Pau Tofu',
        chinese: '宫保豆腐',
        pronunciation: 'Gōng bǎo dòufu',
        category: [DictionaryCategory.Food],
        description: '',
        similar: ['boluogulaorou', 'disanxian', 'congyoubing']
    },
    {
        id: 'boluogulaorou',
        german: 'Bo Luo Gu Lao Rou',
        chinese: '菠萝咕咾肉',
        pronunciation: 'Bōluó gū lǎo ròu',
        category: [DictionaryCategory.Food],
        description: 'Frittiertes-Ananas-Soja-Geschnetzeltes-Gulasch-Süß-Sauer-Art',
        image: 'images/boluogulaorou.jpeg',
        similar: ['kungpaotofu', 'disanxian', 'congyoubing']
    },
    {
        id: 'disanxian',
        german: 'Di San Xian',
        chinese: '地三鲜',
        pronunciation: 'De sān xiān',
        category: [DictionaryCategory.Food],
        description: 'Drei Schätze der Erde, frittiert; Serviert mit Reis',
        image: 'images/disanxian.jpeg',
        similar: ['kungpaotofu', 'boluogulaorou', 'congyoubing']
    },
    {
        id: 'congyoubing',
        german: 'Cong You Bing',
        chinese: '葱油饼',
        pronunciation: 'Cōng yóubǐng',
        category: [DictionaryCategory.Food],
        description: 'Schnittlauch Pfannkuchen',
        image: 'images/congyoubing.jpeg',
        similar: ['kungpaotofu', 'boluogulaorou', 'disanxian']
    },

    // INSULTS
    {
        id: 'guenkai',
        german: 'Fuck off',
        chinese: '滚开',
        pronunciation: 'Gǔn kāi',
        category: [DictionaryCategory.Insults]
    },
    {
        id: 'shabi',
        german: 'Dummkopf',
        chinese: '傻逼',
        pronunciation: 'Shǎbī',
        category: [DictionaryCategory.Insults]
    },
    {
        id: 'hurensohn',
        german: 'Hurensohn',
        chinese: '王八蛋',
        pronunciation: 'Wángbā dàn',
        category: [DictionaryCategory.Insults]
    },
    {
        id: 'zaonima',
        german: 'Motherfucker',
        chinese: '操你妈',
        pronunciation: 'Cāo nǐ mā',
        category: [DictionaryCategory.Insults]
    },
    {
        id: 'biaoze',
        german: 'Bitch',
        chinese: '婊子',
        pronunciation: 'Biǎo zi',
        category: [DictionaryCategory.Insults]
    },

    // PICKUP
    {
        id: 'schlafmitmir',
        german: 'Schlaf mit mir, Baby.',
        chinese: '跟我睡, 宝宝。',
        pronunciation: 'Gēn wǒ shuì, bǎobǎo.',
        category: [DictionaryCategory.PickUp],
        audio: 'audio/schlafmitmir.ogg'
    },
    {
        id: '9und3',
        german: 'Ich bin 9. Du bist 3. Geteilt durch dich ist immer noch du.',
        chinese: '我是九，你是三，除了你，还是你。',
        pronunciation: 'Wǒ shì jiǔ, nǐ shì sān, chúle nǐ, háishì nǐ.',
        category: [DictionaryCategory.PickUp],
        description: '<p>Frei Übersetzt: Alles was ich habe bist du</p>除 (Chú) bedeutet auch "außer", bzw. "ohne"<br>Der Satz kann also zu "Außer dir habe ich immer nur noch dich" übersetzt werden.',
        audio: 'audio/9und3.ogg'
    },
    {
        id: 'mangel',
        german: 'Mir fehlt etwas. - Was fehlt dir? - Du',
        chinese: '我有一个缺点 - 是什么？- 缺点你',
        pronunciation: 'Wǒ yǒu yīgè quēdiǎn - shì shénme?- Quēdiǎn nǐ',
        category: [DictionaryCategory.PickUp],
        description: 'Wörtliche Übersetzung: Ich habe einen Mangel. - Was ist das? - Einen Mangel an dir',
        audio: 'audio/mangel.ogg'
    },

    // ALIEXPRESS
    {
        id: 'defekt',
        german: 'Das zugesandte Produkt ist defekt',
        chinese: '这个寄来的产品是损坏的',
        pronunciation: 'Zhège jì lái de chǎnpǐn shì sǔnhuài de',
        category: [DictionaryCategory.Aliexpress]
    },
    {
        id: 'rueckerstattung',
        german: 'Ich möchte rückerstattet werden',
        chinese: '我想退货',
        pronunciation: 'Wǒ xiǎng tuìhuò',
        category: [DictionaryCategory.Aliexpress]
    },
    {
        id: 'nichtangekommen',
        german: 'Meine Bestellung ist nicht angekommen',
        chinese: '我的订单没寄到',
        pronunciation: 'Wǒ de dìngdān méi jì dào',
        category: [DictionaryCategory.Aliexpress]
    },
    {
        id: 'bestellung',
        german: 'Wo befindet sich meine Bestellung?',
        chinese: '我的订单在哪里？',
        pronunciation: 'Wǒ de dìngdān zài nǎlǐ?',
        category: [DictionaryCategory.Aliexpress]
    },

    // NAMES
    {
        id: 'bradpitt',
        german: 'Brad Pitt',
        chinese: '布拉德 皮特',
        pronunciation: 'Bù lā dé pítè',
        category: [DictionaryCategory.Names],
        image: ''
    },
    {
        id: 'nicolascage',
        german: 'Nicolas Cage',
        chinese: '尼古拉斯 凯奇',
        pronunciation: 'Nígǔlāsī kǎi qí',
        category: [DictionaryCategory.Names],
        image: ''
    }, 
    {
        id: 'andreaswiedenmann',
        german: 'Andreas Wiedenmann',
        chinese: '安德烈亚斯 威德曼',
        pronunciation: 'Ān dé liè yà sī wēi dé màn',
        category: [DictionaryCategory.Names],
        image: 'images/andreaswiedenmann.jpeg'
    },

]
